<template>
    <div fluid @resize="setFooter()">
        <!--CONTACT LIST DATA TABLE-->
        <v-card v-if="$store.state.contacts" class="mb-10">
            <v-card-title>
                <div class="flex-grow-1 pl-2">
                    <v-btn small elevation="0" @click="ippfull=!ippfull" :dark="ippfull">All</v-btn>
                    <v-chip @click="viewNew()"  color="info" v-if="newcontactcount>0 && filter==='all'" >
                        {{newcontactcount}}
                        New
                    </v-chip>
                    <v-chip @click="tabledata = contacts, filter='all'"   v-if="filter!=='all'">
                        All
                    </v-chip>
                </div>
                <v-text-field
                        v-model="search"
                        :append-icon="icons.search"
                        label="Search by email, cell or status"
                        single-line
                        hide-details
                        clearable
                ></v-text-field>
            </v-card-title>
            <v-data-table
               :key="kt"
               class="pb-10"
               v-model="selectedcontacts"
               item-key="uuid"
               :search="search"
               :page.sync="page"
               show-select
               :dense="$vuetify.breakpoint.xs"
               :headers="headers"
               :items="tabledata"
               :items-per-page="ippfull?-1:($vuetify.breakpoint.xs?15:10)"
               :mobile-breakpoint="300"
               @click:row="openContact($event)"
               @update:page="handlePage($event)"
               @page-count="pageCount = $event"
               :sortBy="sortby"
            >
                <template v-slot:item.status="{ item }">
                    <v-chip dense :color="(item.status==='new')?'info':''" class="text-capitalize">
                        {{item.status}}
                    </v-chip>
                </template>
            </v-data-table>
            <v-card-actions v-if="$vuetify.breakpoint.mdAndUp">
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </v-card-actions>
        </v-card>

        <!--THE CONTACT DIALOG-->
        <!--<v-dialog-->
            <!--max-width="500"-->
            <!--:fullscreen="$vuetify.breakpoint.xs"-->
            <!--v-model="activecontact"-->
            <!--v-if="activecontact"-->
            <!--persistent scrollable>-->
            <!--<ContactEditor :contact="activecontact" :info="activecontact.info"  />-->
        <!--</v-dialog>-->

        <!--MultiSelect Dialog-->
        <v-dialog
                v-model="multiselectdialog"
                hide-overlay
                scrollable
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    {{selectedcontacts.length}} SELECTED
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeMultiSelect()"><v-icon>{{$store.state.icons.close}}</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-row v-if="quickappy">
                            <v-col cols="12" class="pb-0">
                                <v-textarea  outlined v-model="texttosend"></v-textarea>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                                <v-btn @click="sendQuickAppy()" :disabled="!texttosend" text >Send</v-btn>
                            </v-col>
                        </v-row>
                        <v-flex xs12>
                            <v-chip v-for="(d,i) in selectedcontacts"
                                    min-width="200"
                                    :key="d.uuid"
                                class="ma-2"
                                close
                                :color="$store.state.color1"
                                text-color="white"
                                @click:close="selectedcontacts.splice(i,1)"
                                >
                                {{d.name}}
                            </v-chip>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn text  value="recent" @click="closeMultiSelect()">
                        <v-icon>{{$store.state.icons.ban}}</v-icon>
                        <span class="pr-1">Clear All</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text  value="recent" @click="groupsdialog=true">
                        <span class="hidden-xs-only pr-1">Add to Group</span>
                        <v-icon class="hidden-sm-and-up pr-1">{{$store.state.icons.plus}}</v-icon>
                        <v-icon>{{$store.state.icons.group}}</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text :disabled="quickappy"  value="recent" @click="quickappy=true">
                        <span class="hidden-xs-only pr-1">QuickAppy</span>
                        <v-icon>{{icons.sms}}</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Add to Group Dialog -->
        <v-dialog
                v-model="groupsdialog"
                hide-overlay
                scrollable
                max-width="500px">
            <v-card>
                <v-card-title>
                    Add to group:
                    <v-spacer></v-spacer>
                    <v-btn icon  @click.native="groupsdialog=false, editcontactgroups=false">
                        <v-icon>{{$store.state.icons.close}}</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <GroupList :callback="addToGroup" :icon="$store.state.icons.plus" groups="groups"  />
                </v-card-text>
                <v-card-actions>
                    <BaseBtn text @click.native="groupsdialog=false, editcontactgroups=false">Cancel</BaseBtn>
                    <v-spacer></v-spacer>
                    <NewGroup />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--SPEED DIAL-->
        <v-speed-dial
                v-model="fab"
                bottom
                right
                fixed
                direction="top"
                transition="slide-y-reverse-transition"
                class="mb-12"
        >
            <template v-slot:activator>
                <v-btn
                        v-model="fab"
                        color="indigo"
                        dark
                        fab>
                    <v-icon v-if="fab">{{icons.close}}</v-icon>
                    <v-icon v-else>{{icons.plus}}</v-icon>
                </v-btn>
            </template>
            <v-btn
                    fab
                    :dark="selectedcontacts.length===0"
                    :color="selectedcontacts.length===0?'indigo':'green'"
                    @click="(selectedcontacts.length===0)?selectgroupsdialog=true:multiselectdialog=true,fab=true"
            >
                <v-icon v-if="selectedcontacts.length===0">{{icons.group}}</v-icon>
                <span v-else class="font-weight-black display-1 white--text">
                   {{selectedcontacts.length}}
                </span>
            </v-btn>
            <v-btn
                    fab
                    dark
                    color="blue"
                    @click="newContact(), contact={cell:''}, contactdisabled=false,fab=true"
            >
                <v-icon>{{icons.adduser}}</v-icon>
            </v-btn>
        </v-speed-dial>


        <v-footer
                fixed
                padless
                v-if="$vuetify.breakpoint.smAndDown"

        >
            <v-card :key="footerkey">
                <v-card-text>
                    <v-layout row>
                        <v-pagination v-model="page" :length="pageCount"></v-pagination>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-footer>
        <GroupsDialog :dialog="selectgroupsdialog" @close="selectgroupsdialog=false"  />
    </div>
</template>

<script>
  import {
    mapState,
    mapMutations,
    mapGetters,
    mapActions
  } from 'vuex'
  import NewGroup from "../groups/NewGroup";
  import GroupsDialog from "../groups/GroupsDialog";
  import BaseBtn from "../BaseBtn";
  import GroupList from "../groups/GroupList";
  //import ContactEditor from "./ContactEditor";
  export default {
    components: { /*ContactEditor,*/ GroupList, BaseBtn, GroupsDialog, NewGroup},
    name: "ContactC",
    data:() => {
      return {
        footerkey:'0000',
        tabledata:undefined,
        loading:false,
        contactdialog:false,
        contactdisabled:true,
        search:'',
        contact: {
          name:'',
          email:'',
          instagram:'',
          cell:''
        },
        contactinfo:undefined,
        originalcontact: {},
        valid:undefined,
        headers: [
          //NOTE: IF HEADERS IS NOT MODIFYING, CHECK THE onResize() function
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'Cell', value: 'cell', class:'hidden-xs-and-down' },
          { text: 'Email', value: 'email', class:'hidden-xs-and-down' },
          { text: 'Status', value: 'status', class: 'hidden-xs-and-down'}
        ],
        expanded: [],
        selectedcontacts: [],
        singleselectedcontact: [],
        multiselectdialog:false,
        quicktextdialog:false,
        groupsdialog:false,//false,
        selectgroupsdialog:false,
        editcontactgroups:false,
        dense:false,
        page: 1,
        pageCount: 0,
        fab:false,
        sortby: 'name',
        sortdesc: true,
        kt: new Date().getTime(),
        filter: 'all',
        quickappy: false,
        texttosend: undefined,
        ippfull: true
      }
    },
    computed: {
      ...mapState('cognito', ['user']),
      ...mapState(['icons','contacts','newcontactcount','activecontact']),
      ...mapGetters('cognito', ['isLoggedIn']),
    },
    watch:{
      selectedcontacts(n,o){
        if(n.length>0){
          this.fab = true
        } else {
          this.fab = false
        }
      }
    },
    mounted() {
      if(this.$store.state.activegroup){
        this.selectgroupsdialog = true;
      }
      this.onResize()
      this.tabledata = this.contacts
    },
    methods: {
      ...mapMutations([
        'setAppdata', 'setOrg', 'setSub', 'setActiveVideo', 'setVideos', 'setVideoList','setActiveContact'
      ]),
      ...mapActions(['getActiveContact','post','get']),
      onResize: function(){
        if(this.$vuetify.breakpoint.xs){
          this.headers = [
            {
              text: 'name',
              align: 'left',
              value: 'name',
            }
          ]
        } else {
          this.headers = [
            {
              text: 'Name',
              align: 'left',
              value: 'name'
            },
            { text: 'Cell', value: 'cell', class:'hidden-xs-and-down' },
            { text: 'Email', value: 'email', class:'hidden-xs-and-down' },
            { text: 'Status', value: 'status', class: 'hidden-xs-and-down'}
          ]
        }
      },
      newContact(){
        this.$store.dispatch('newContact')
        this.$router.push('/contacts/edit/'+undefined)
      },
      openContact: async function (contact) {
        if(contact.status==='new')contact.status = 'active'
        //triggers the contact dialog panel
        // Object.assign(this.contact,ct);
        // Object.assign(this.originalcontact,ct); //storing if we dont want to save
        this.setActiveContact({info:contact})
        this.getActiveContact(contact.uuid)
        this.$router.push('/contacts/edit/'+contact.uuid)
      },
      closecontact: function(){
        this.$store.commit('setActiveContact',false)
        this.loading=false;
        this.contactdisabled=true
        this.contactinfo=undefined;
        this.singleselectedcontact=[];
      },
      addToGroup: async function(group) {
        let em = this;
        em.loading=true;
        //if its only one contact, in the single selected, then its a call from the contact dialog. we ignore
        //any other slectedcontacts for this call. else, its a normal multiselect
        let c = (this.singleselectedcontact.length===1)?this.singleselectedcontact:this.selectedcontacts
        let args;
        args = {
          url:this.$store.state.url + 'api/groups/addtogroupmultiv2',
          method:"POST",
          data:{
            contacts:c,
            groupkey:group.groupkey,
            groupname:group.name,
            name:group.name,
            orgkey:this.$store.state.org.partkey
          }
        }
        this.$store.dispatch('fetch',args).then(async res =>{
          console.log(res)
          em.loading=false
          em.groupsdialog=false
          em.multiselectdialog=false;
          if(em.singleselectedcontact.length===1){
            console.log(em.singleselectedcontact[0].uuid)
            em.opencontact(em.singleselectedcontact[0])
            em.singleselectedcontact = []
          } else {
            em.selectedcontacts=[]
          }
          em.$store.commit('setSnackbar',{
            type: 'success',
            msg: res.msg,
            timeout:6000
          })
        }).catch(e=>{console.log(e)})
      },
      removeFromGroup: async function(d,c){ console.log(d,c)
        let data = {
          groupkey:d,
          contactuuid:c
        }
        let res = await this.$store.dispatch('removeFromGroup',data);
        this.editcontactgroups = false;
        console.log(this.contactinfo)
        this.opencontact({
          cell:this.contactinfo.info.cell,
          email:this.contactinfo.info.email,
          uuid:this.contactinfo.info.uuid,
          name:this.contactinfo.info.name
        })
        console.log(res)
      },
      toggleOrder () {
        this.descending = !this.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.sortBy)
        index = (index + 1) % this.headers.length
        this.sortBy = this.headers[index].value
      },
      handlePage(e){
        this.page = e
      },
      viewNew(){
        this.tabledata = this.contacts.filter(f=>{ return f.status==='new'})
        this.filter = 'new'
      },
      async sendQuickAppy(){
        this.loading = true;
        if(this.texttosend.length<4){
          return;
        }
        //ONLY SEND AN ARRAY OF GROUP KEYS
        let body = {
          quickappy: true,
          contacts: this.selectedcontacts,
          message: this.texttosend,
          loading:false,
          includeemail: this.includeemail,
          mediaUrl: this.mediaUrl,
          issurvey: false,
          question:'',
          answers:this.answers,
          requestyesno: this.requestyesno
        }
        let response = await this.post({path:'api/sendsms/sendtexttogroupv2', body:body})
        this.loading=false;
        if(response.error){
          this.$store.commit('setSnackbar',{
            type: 'warning',
            msg: response.message,
            timeout:6000
          })
          return console.log(response.error)
        }
        this.$store.commit('setSelectedGroups',[])
        this.texttosend='';
        this.quickappy = false
        this.$store.commit('setSnackbar',{
          type: 'success',
          msg: 'Message sent. Go to the history page to see results',
          timeout:6000
        })
        this.$store.commit('setActiveSentRecord',response.item)
        //this.$router.replace('/history')
      },
      closeMultiSelect(){
        this.multiselectdialog=false;
        this.texttosend=undefined;
        this.quickappy=false;
        this.selectedcontacts=[];
      },
      setFooter(){
        this.footerkey=new Date().getTime()
      }
    }
  }
</script>

<style scoped>

</style>